module.exports = __webpack_public_path__ + "static/media/House-Keeping.d1d43c10.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/general/House-Keeping.png
// module id = 109
// module chunks = 0